import * as Sentry from '@sentry/react';

export enum StorageKeys {
  IMPERSONATION_EMAIL = 'impersonation_email',
  IMPERSONATION_ID = 'impersonation_id',
  LOCAL_STORE_FULLSTORY_FLAG = 'fullstory_enabled',
  LOCAL_STORE_FULLSTORY_TIMESTAMP = 'fullstory_timestamp',

  FREDDIE_POPUP = 'promo_freddie-popup',
  FREDDIE_HEADER = 'promo_freddie-header',
  FANNIE_POPUP = 'promo_fannie-popup',
  FANNIE_HEADER = 'promo_fannie-header',
  VOA_POPUP = 'promo_voa-popup',
  VOA_HEADER = 'promo_voa-header',
  VOA_FANNIE_POPUP = 'promo_voa-fannie-popup',
  VOA_FANNIE_HEADER = 'promo_voa-fannie-header',
  SUBSCRIPTION_HEADER = 'promo_subscription-header',
  ACCOUNT_ACTIVATION_HEADER = 'promo_account-activation-header',

  // Integration
  WORKNUMBER = 'worknumber',
  EXPERIAN = 'experian',
  TRUEWORK = 'truework',
  OCROLUS = 'ocrolus',
  INFORMED = 'informed',
  SIMPLENEXUS = 'simplenexus',
  BANNO = 'banno',
  BLACKKNIGHT = 'blackknight',
  ACCIO = 'accio',
  ENCOMPASS = 'encompass',
  CONSTELLATION = 'constellation',
  TAZWORKS = 'tazworks',
  TWILIO = 'twilio',

  COMMON_FILTERS = 'common_filters',

  // DataGrid
  ORDERS_TABLE_COLUMNS = 'orders_table_columns',
  USERS_TABLE_COLUMNS = 'users_table_columns',
  BILLING_USAGE_TABLE_COLUMNS = 'billing_usage_table_columns',
}

const handleStorageError = <T>(fn: () => T): T | undefined => {
  try {
    return fn();
  } catch (err) {
    console.error('localStorage error:', err);
    Sentry.captureException(err);

    return undefined;
  }
};

export const createStorageService = (storage: Storage) => ({
  get: (key: StorageKeys) =>
    handleStorageError(() => {
      const value = storage.getItem(key);

      if (!value) {
        return undefined;
      }

      try {
        return JSON.parse(value);
      } catch (err) {
        // If JSON parsing fails, return the raw string value
        return value;
      }
    }),
  set: (key: StorageKeys, value: unknown) => handleStorageError(() => storage.setItem(key, JSON.stringify(value))),
  remove: (key: StorageKeys) => handleStorageError(() => storage.removeItem(key)),
});

export const localStorageService = createStorageService(localStorage);
export const sessionStorageService = createStorageService(sessionStorage);
